import { Swatch } from '@/components/ui'
import { cn } from '@/utils'

interface TallyProps {
  label: string
  count: number
  dotClassName: string
  // Given a handler the tally becomes a filter toggle, and `isActive` shows which one is on.
  onClick?: () => void
  isActive?: boolean
}

// Dot + count + label tally. Shared by the statements status bar and the reconciliation summary.
export const Tally = ({
  label,
  count,
  dotClassName,
  onClick,
  isActive = false,
}: TallyProps) => {
  const content = (
    <>
      <Swatch size="lg" shape="square" className={dotClassName} />
      <span className="font-semibold tabular-nums text-foreground">
        {count}
      </span>
      <span className="text-muted-foreground">{label}</span>
    </>
  )

  if (!onClick) {
    return <div className="flex items-center gap-1.5">{content}</div>
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={isActive}
      className={cn(
        'flex cursor-pointer items-center gap-1.5 rounded-md px-1.5 py-0.5 transition-colors hover:bg-neutral-100',
        isActive && 'bg-neutral-100 ring-1 ring-border',
      )}
    >
      {content}
    </button>
  )
}
